interface HeroSectionProps {
  shop: {
    name: string;
    category: string[];
    description: string;
    location: string;
    reviewCount: number;
    photoCount: number;
    verified: boolean;
  };
  images: {
    mobile: string;
    desktop: string;
    gallery: string[]
  };
}

export default function HeroSection({ shop, images = {} }: HeroSectionProps) {
  return (
    <div>
      {/* Mobile Hero */}
      <div className="lg:hidden">
        <div className="relative aspect-[3/4]">
          <img
            src={images.mobile}
            alt={`${shop.name} 대표 화보`}
            className="w-full h-full object-cover"
          />
          <div className="absolute bottom-3 right-3 bg-black/60 text-white text-xs px-2.5 py-1 rounded-full font-medium">
            1 / 6
          </div>
        </div>

        {/* Mobile Info Panel */}
        <div className="px-4 py-5">
          <h1 className="text-2xl font-bold text-[#121B35] leading-tight">
            {shop.name}
          </h1>
          <div className="flex gap-2 mt-2.5">
            {shop.category?.map((c) => (
              <span
                key={c}
                className="bg-[#F7F2EA] text-[#121B35] text-xs md:text-sm px-2.5 py-1 rounded-full font-medium"
              >
                {c}
              </span>
            ))}
          </div>
          <p className="text-sm text-[#536079] mt-3 leading-relaxed">
            {shop.description}
          </p>
          <div className="flex items-center gap-2 mt-3 text-xs md:text-sm text-[#536079]">
            <span>{shop.location}</span>
            <span className="text-[#E8E2DA]">·</span>
            <span>실제 후기 {shop.reviewCount}개</span>
            <span className="text-[#E8E2DA]">·</span>
            <span>후기 사진 {shop.photoCount}장</span>
          </div>
          {shop.verified && (
            <div className="mt-3 inline-flex items-center gap-1.5 bg-[#121B35] text-white text-xs md:text-sm px-3 py-1.5 rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-[#B9965B]" />
              다이렉트웨딩 후기 기반 검증 업체
            </div>
          )}
        </div>
      </div>

      {/* Desktop 5-split Gallery */}
      <div className="hidden lg:flex lg:gap-3 lg:max-h-[520px]">
        <div className="relative w-[58%] rounded-2xl overflow-hidden">
          <img
            src={images.desktop}
            alt={`${shop.name} 대표 화보`}
            className="w-full h-full object-cover"
          />
          {/* <div className="absolute bottom-4 right-4 bg-black/60 text-white text-xs px-3 py-1.5 rounded-full font-medium">
            1 / 6
          </div> */}
        </div>

        <div className="w-[42%] grid grid-cols-2 grid-rows-2 gap-3">
          {images.gallery?.map((src, i) => (
            <div
              key={i}
              className="relative rounded-2xl overflow-hidden"
            >
              <img
                src={src}
                alt={`갤러리 ${i + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}